<app-context-menu-button [actions]="tenantActions" [positionPreference]="'bottomLeft'"
                         (onActionClicked)="handleTenantActions($event)">
</app-context-menu-button>
